import * as z from "zod"

import { safelyExtractEnvVar } from "@repo/utils"

export const configSchema = z.object({
  appEnv: z.string({ error: "APP_ENV is required" }).default("development"),
})

export type Config = z.infer<typeof configSchema>

export const config = configSchema.parse({
  appEnv: safelyExtractEnvVar(["APP_ENV", "VITE_APP_ENV"]),
})
